/* bj-preorder-note.js (Billy, 8 Sep 2026)
   Keeps the cart NOTE in sync with pre-order items so the packing team sees it.
   Why: the pre-order flag is a line item property ("PRE ORDER - Waiting on stock"), and neither
   Shopify's packing slip nor Starshipit prints line item properties. Both DO print the order note
   (Shopify packing slip "Notes" block; Starshipit imports notes). So whenever the cart holds a
   pre-order item we write one line at the top of the note, and remove it again if the item goes.
   Anything the customer typed in the note is kept untouched (we only own lines starting with MARK). */
(function () {
  var KEY = 'PRE ORDER - Waiting on stock';
  var MARK = '*** PRE ORDER';
  var busy = false, again = false;

  function build(cart) {
    var items = (cart.items || []).filter(function (i) { return i.properties && i.properties[KEY]; });
    if (!items.length) return '';
    var parts = items.map(function (i) {
      return i.product_title + (i.variant_title ? ' (' + i.variant_title + ')' : '') + ' x' + i.quantity;
    });
    var ship = String(items[0].properties[KEY]).split(' - ')[0];   /* "Ships before 28 September" */
    return MARK + ' - SET THIS ORDER ASIDE *** ' + parts.join(', ') + '. ' + ship + '.';
  }
  function compose(existing, ours) {
    var rest = String(existing || '').split('\n')
      .filter(function (l) { return l.indexOf(MARK) !== 0; })
      .join('\n').replace(/^\n+|\n+$/g, '');
    if (!ours) return rest;
    return rest ? ours + '\n' + rest : ours;
  }
  function run() {
    if (busy) { again = true; return; }
    busy = true; again = false;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var want = compose(cart.note, build(cart));
        var have = String(cart.note || '');
        if (want === have) return;
        return fetch('/cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-BJ-Preo': '1' },
          body: JSON.stringify({ note: want })
        });
      })
      .catch(function () {})
      .then(function () { busy = false; if (again) setTimeout(run, 300); });
  }
  function later(ms) { setTimeout(run, ms); }

  /* run after any cart mutation the theme or our snippets make (add / change / update / clear) */
  if (window.fetch && !window.fetch.__bjPreo) {
    var orig = window.fetch;
    var wrapped = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var ours = init && init.headers && init.headers['X-BJ-Preo'];
      var p = orig.apply(this, arguments);
      if (!ours && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) { p.then(function () { later(250); }, function () {}); }
      return p;
    };
    wrapped.__bjPreo = true;
    window.fetch = wrapped;
  }
  document.addEventListener('theme:cart:refresh', function () { later(400); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { later(1500); });
  else later(1500);
})();
